import Select from "components/widgets/Select";
import useApp from "hooks/useApp";
import classNames from "utilities/ClassNames";
export default function AreaConfiguration({
  area,
  setArea,
  handleConfiguration,
  setScreen,
  configError,
}: any) {
  const { isScaled } = useApp();
  return (
    <form className="flex flex-col gap-3 w-11/12 mx-auto">
      {/* K1 */}
      <div className="flex flex-1 gap-3 w-full items-center">
        <div className="w-1/2">
          <input
            placeholder="Name"
            className={classNames(isScaled ? "text-lg h-11" : "", "input")}
            name="name"
            id="name"
            type="text"
            required
            value={area.name}
            onChange={(e: any) =>
              setArea((prev: any) => ({
                ...prev,
                name: e.target.value,
              }))
            }
          />
        </div>
        <div className="w-1/2">
          <Select
            id={area.id}
            selectedValue={area.value}
            type={area.type}
            clear={() => setArea({ id: "", name: "", value: "", type: "" })}
            select={({ item, typeSelected }: any) => {
              setArea((prev: any) => ({
                ...prev,
                id: item.id,
                value: item,
                type: typeSelected,
              }));
            }}
          />
        </div>
      </div>
      <div className="flex gap-1 justify-end mt-3">
        <div className="text-red">{configError}</div>
        <div className="flex items-center gap-3">
          <div
            onClick={() => {
              setScreen("");
            }}
            className="btn-sec"
          >
            Cancel
          </div>
          <div onClick={handleConfiguration} className="btn">
            Commit
          </div>
        </div>
      </div>
    </form>
  );
}
